import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import {bindActionCreators} from "redux";
import {loginAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import * as MainConstants from "../../utils/MainConstants";
import Image from 'material-ui-image'
import {Link} from "react-router-dom";
import ContactUs from "./ContactUs";
import Divider from "@material-ui/core/Divider";


const Styles = theme => ({
  root: Object.assign({}, AppBackground, MediumFont),
  gridPane: {width: '50%', display: 'inline-block'},
  paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
  videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
  penInfoPanel: {color: 'white', fontSize: 20},
  penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
  videoPanel: {marginTop: 0},
  penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
  metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  metricInfo: Object.assign({}, AppBackground, ThinBorder)
});

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
  rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  margin: {
    margin: theme.spacing.unit * 2,
  },
  dividerColorPurpole: {
    height: '20px',
    color:"#ffffff",
  },
});

const GREEN       = '#1a736a';
const GREEN_LIGHT = '#f0f7f5';
const DARK        = '#1a2e1d';
const GRAY        = '#555';

const policyCard = (extra) => Object.assign({
  backgroundColor: '#ffffff',
  borderRadius: 10,
  padding: '28px 28px',
  boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
  marginBottom: 20,
}, extra || {});

const sectionTitle = {
  fontSize: 18,
  fontWeight: 700,
  color: GREEN,
  marginBottom: 12,
  marginTop: 0,
};

const bodyText = {
  fontSize: 15,
  color: GRAY,
  lineHeight: 1.8,
  marginBottom: 0,
  marginTop: 0,
};

const listItem = {
  fontSize: 15,
  color: GRAY,
  lineHeight: 1.8,
  marginBottom: 4,
};


class SaveTime extends Component {

  state = {
    age: '',
    name: 'hai',
  };

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  constructor(props) {
    super(props);
    this.towAgentClick = this.towAgentClick.bind(this);
    this.vehicleOwnerClick = this.vehicleOwnerClick.bind(this);
  }

  towAgentClick(){
    this.props.towAgentConfigCall();
  }

  vehicleOwnerClick(){
    let { loginAction } = this.props;
    loginAction();
  }

  render() {
    window.scrollTo(0, 0);
    return (
      <div style={{ backgroundColor: '#f9f9f7', minHeight: '100vh' }}>

        {/* Top nav */}
        <div style={{ backgroundColor: DARK, padding: '14px 24px' }}>
          <a href="/home" style={{ color: '#ffffff', textDecoration: 'none', fontSize: 14, fontWeight: 600, letterSpacing: 0.5 }}>
            ← Back to Orchima Home
          </a>
        </div>

        {/* Hero */}
        <div style={{ backgroundColor: GREEN, padding: '56px 24px', textAlign: 'center' }}>
          <p style={{ fontSize: 12, fontWeight: 700, color: '#a8d5cf', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 12, marginTop: 0 }}>
            LEGAL
          </p>
          <h1 style={{ fontSize: 'clamp(24px, 5vw, 34px)', fontWeight: 700, color: '#ffffff', lineHeight: 1.3, margin: '0 auto 16px auto', maxWidth: 600 }}>
            Privacy Policy
          </h1>
          <p style={{ fontSize: 16, color: '#d0ede9', maxWidth: 560, margin: '0 auto', lineHeight: 1.7 }}>
            Orchima™ by Vespaan Corporation — we take your privacy seriously and handle your information responsibly.
          </p>
        </div>

        {/* Content */}
        <div style={{ maxWidth: 760, margin: '0 auto', padding: '48px 24px' }}>

          {/* Intro */}
          <div style={policyCard({ backgroundColor: GREEN_LIGHT })}>
            <p style={{ fontSize: 16, color: DARK, lineHeight: 1.8, margin: 0 }}>
              Welcome to Orchima™, an orchid care system developed by Vespaan Corporation. This Privacy Policy
              explains what information we collect, how we use it, and what choices you have. We keep this plain
              and readable on purpose — no jargon.
            </p>
            <p style={{ fontSize: 13, color: '#888', marginTop: 12, marginBottom: 0 }}>
              Effective date: 2025 &nbsp;·&nbsp; Questions? <a href="/contactus" style={{ color: GREEN }}>Contact us</a>
            </p>
          </div>

          {/* 1. What We Collect */}
          <div style={policyCard()}>
            <h2 style={sectionTitle}>1. Information We Collect</h2>
            <p style={{ ...bodyText, marginBottom: 16 }}>
              We only collect information that helps us operate and improve Orchima™.
            </p>

            <p style={{ fontSize: 14, fontWeight: 700, color: DARK, marginBottom: 8, marginTop: 0 }}>Personal information you provide:</p>
            <ul style={{ paddingLeft: 20, marginTop: 0, marginBottom: 16 }}>
              {['Name', 'Email address', 'Phone number (if provided)', 'Mailing or shipping address'].map((item, i) => (
                <li key={i} style={listItem}>{item}</li>
              ))}
            </ul>
            <p style={{ fontSize: 14, color: GRAY, lineHeight: 1.7, marginBottom: 16, marginTop: 0 }}>
              This is collected when you submit feedback, contact us, make a purchase, or sign up for updates.
            </p>

            <p style={{ fontSize: 14, fontWeight: 700, color: DARK, marginBottom: 8, marginTop: 0 }}>Usage &amp; technical data (collected automatically):</p>
            <ul style={{ paddingLeft: 20, marginTop: 0, marginBottom: 16 }}>
              {['IP address', 'Browser and device type', 'Operating system', 'Pages visited and how you interact with the site'].map((item, i) => (
                <li key={i} style={listItem}>{item}</li>
              ))}
            </ul>
            <p style={{ fontSize: 14, color: GRAY, lineHeight: 1.7, marginBottom: 0, marginTop: 0 }}>
              This helps us understand how people use the site and make it better.
            </p>
          </div>

          {/* 2. How We Use It */}
          <div style={policyCard()}>
            <h2 style={sectionTitle}>2. How We Use Your Information</h2>
            <p style={{ ...bodyText, marginBottom: 12 }}>We use the information we collect to:</p>
            <ul style={{ paddingLeft: 20, margin: 0 }}>
              {[
                'Operate our website and fulfill orders',
                'Respond to your questions and support requests',
                'Improve our products and the customer experience',
                'Send product updates or promotional content (only when you\'ve permitted it)',
              ].map((item, i) => (
                <li key={i} style={listItem}>{item}</li>
              ))}
            </ul>
          </div>

          {/* 3. How We Share It */}
          <div style={policyCard()}>
            <h2 style={sectionTitle}>3. How We Share Your Information</h2>
            <p style={{ ...bodyText, marginBottom: 16 }}>
              We do not sell your personal information. We share it only in these limited situations:
            </p>

            <div style={{ borderLeft: '3px solid #ddd', paddingLeft: 16, marginBottom: 16 }}>
              <p style={{ fontSize: 14, fontWeight: 700, color: DARK, marginBottom: 6, marginTop: 0 }}>Service providers</p>
              <p style={{ fontSize: 14, color: GRAY, lineHeight: 1.7, margin: 0 }}>
                Trusted third parties who help us run the business — payment processors, hosting providers,
                and communication services. They only receive information necessary to do their job.
              </p>
            </div>

            <div style={{ borderLeft: '3px solid #ddd', paddingLeft: 16 }}>
              <p style={{ fontSize: 14, fontWeight: 700, color: DARK, marginBottom: 6, marginTop: 0 }}>Legal requirements</p>
              <p style={{ fontSize: 14, color: GRAY, lineHeight: 1.7, margin: 0 }}>
                We may disclose information if required to comply with legal obligations, protect our rights,
                or prevent fraud.
              </p>
            </div>
          </div>

          {/* 4. Payment */}
          <div style={policyCard()}>
            <h2 style={sectionTitle}>4. Payment Information</h2>
            <p style={bodyText}>
              When you make a purchase, payment details are processed securely through third-party payment
              providers. We do not store full credit card numbers on our servers.
            </p>
          </div>

          {/* 5. Security */}
          <div style={policyCard()}>
            <h2 style={sectionTitle}>5. Data Security</h2>
            <p style={bodyText}>
              We use reasonable administrative, technical, and physical safeguards to protect your information.
              That said, no system is completely secure — we cannot guarantee the absolute security of data
              transmitted over the internet.
            </p>
          </div>

          {/* 6. Your Choices */}
          <div style={policyCard()}>
            <h2 style={sectionTitle}>6. Your Choices &amp; Rights</h2>
            <p style={{ ...bodyText, marginBottom: 12 }}>You can:</p>
            <ul style={{ paddingLeft: 20, marginBottom: 16, marginTop: 0 }}>
              {[
                'Opt out of marketing communications at any time',
                'Request access to the personal data we hold about you',
                'Request correction or deletion of your information',
              ].map((item, i) => (
                <li key={i} style={listItem}>{item}</li>
              ))}
            </ul>
            <p style={{ fontSize: 14, color: GRAY, lineHeight: 1.7, marginBottom: 12, marginTop: 0 }}>
              To opt out of communications or service participation:
            </p>
            <a href="/optout" style={{ color: GREEN, fontWeight: 600, fontSize: 15, textDecoration: 'none' }}>
              Opt out from communications →
            </a>
          </div>

          {/* 7. Changes */}
          <div style={policyCard()}>
            <h2 style={sectionTitle}>7. Changes to This Policy</h2>
            <p style={bodyText}>
              We may update this Privacy Policy from time to time to reflect changes in our practices or legal
              requirements. Updates will appear on this page with a revised effective date. We encourage you
              to check back periodically.
            </p>
          </div>

          {/* 8. Contact */}
          <div style={{ backgroundColor: DARK, borderRadius: 10, padding: '28px 28px', marginBottom: 48 }}>
            <h2 style={{ fontSize: 18, fontWeight: 700, color: '#ffffff', marginBottom: 12, marginTop: 0 }}>
              8. Questions or Concerns?
            </h2>
            <p style={{ fontSize: 15, color: '#b8cfc8', lineHeight: 1.8, marginBottom: 20, marginTop: 0 }}>
              If you have any questions about this Privacy Policy or how your information is handled,
              we're happy to help.
            </p>
            <a
              href="/contactus"
              style={{
                display: 'inline-block',
                backgroundColor: GREEN,
                color: '#ffffff',
                textDecoration: 'none',
                fontWeight: 600,
                fontSize: 15,
                padding: '10px 24px',
                borderRadius: 6,
              }}
            >
              Contact Us
            </a>
          </div>

          {/* Footer */}
          <div style={{ textAlign: 'center', paddingBottom: 24 }}>
            <a href="/home" style={{ color: GREEN, fontWeight: 600, fontSize: 16, textDecoration: 'none' }}>
              ← Back to Orchima Home
            </a>
          </div>

        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    loginAction:loginAction,
  }, dispatch);
};

SaveTime.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SaveTime));
